import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import MutedFilledSvg from "@ant-design/icons-svg/es/asn/MutedFilled";
import AntdIcon from "../components/AntdIcon";
var MutedFilled = function MutedFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MutedFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  MutedFilled.displayName = 'MutedFilled';
}
export default /*#__PURE__*/React.forwardRef(MutedFilled);